// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#publicPortalApp {
    height: 100vh;
    overflow: hidden;
}

#terms-and-conditions * {
    list-style: initial;
    list-style-position: inside;
}

:root {
    --public-portal-primary: #0357a6;
    --public-portal-primary-hover: rgba(3, 87, 166, 0.8);
    --public-portal-small-hover: rgba(4, 86, 159, 0.8);
    --public-portal-secondary-focus: rgba(3, 87, 166, 0.4);
    --public-portal-card: #f7f7f7;
    --public-portal-white: #ffffff;
    --error-red: #e74c3c;
    --gradientBackground-height: 30vh;
}

.publicPortalField {
    width: 300px;
}
.publicPortalField--address {
    width: 600px;
}

.cursor-pointer:hover {
    cursor: pointer;
}

@media (max-width: 992px) {
    .publicPortalField {
        width: 100%;
    }
}

@media (max-width: 700px) {
    .publicPortalField {
        width: 100%;
    }

    .grid-nextItem {
        padding-top: 0 !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,oDAAoD;IACpD,kDAAkD;IAClD,sDAAsD;IACtD,6BAA6B;IAC7B,8BAA8B;IAC9B,oBAAoB;IACpB,iCAAiC;AACrC;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["#publicPortalApp {\n    height: 100vh;\n    overflow: hidden;\n}\n\n#terms-and-conditions * {\n    list-style: initial;\n    list-style-position: inside;\n}\n\n:root {\n    --public-portal-primary: #0357a6;\n    --public-portal-primary-hover: rgba(3, 87, 166, 0.8);\n    --public-portal-small-hover: rgba(4, 86, 159, 0.8);\n    --public-portal-secondary-focus: rgba(3, 87, 166, 0.4);\n    --public-portal-card: #f7f7f7;\n    --public-portal-white: #ffffff;\n    --error-red: #e74c3c;\n    --gradientBackground-height: 30vh;\n}\n\n.publicPortalField {\n    width: 300px;\n}\n.publicPortalField--address {\n    width: 600px;\n}\n\n.cursor-pointer:hover {\n    cursor: pointer;\n}\n\n@media (max-width: 992px) {\n    .publicPortalField {\n        width: 100%;\n    }\n}\n\n@media (max-width: 700px) {\n    .publicPortalField {\n        width: 100%;\n    }\n\n    .grid-nextItem {\n        padding-top: 0 !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
